import {
    Component,
    ViewChild,
    Injector,
    Output,
    EventEmitter,
    ElementRef,
    ViewEncapsulation,
    Input,
    OnInit,
} from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { ModalDirective } from "ngx-bootstrap";
import { AppComponentBase } from "@shared/common/app-component-base";
import {
    CreateOrEditEventDto,
    EventsServiceProxy,
    EventTypesServiceProxy,
    EventCategoryDeadlineDto,
    EventPaymentMethodPermissionDto,
    PaymentMethodsServiceProxy,
    EventPlaceDto,
    EventAddressDto,
    UpdateEventImageInput,
    ContractDto,
    CertificateConfigDto,
    UpdateCertificateImageInput,
    CertificatesServiceProxy,
    GetCertificatePreviewInput,
    CertificatePreviewEvent,
    CertificateConfigTextDto,
    DocumentDto,
    EmailConfigDto,
    DocumentEditDto,
    UpdateDocumentInput,
    UserServiceProxy,
    LanguageTextDto,
} from "@shared/service-proxies/service-proxies";

import * as _ from "lodash";
import * as moment from "moment";
import { AddressesComponent } from "@app/shared/common/addresses/addresses/addresses.component";
import {
    EventAddressType,
    PaymentMethod,
    CertificateType,
    StatusIntegracao,
} from "@shared/AppEnums";
import { FileUploader, FileUploaderOptions } from "ng2-file-upload";
import { AppConsts } from "@shared/AppConsts";
import { IAjaxResponse } from "@abp/abpHttpInterceptor";
import { TokenService } from "@abp/auth/token.service";
import { DomSanitizer } from "@angular/platform-browser";
import { FileDownloadService } from "@shared/utils/file-download.service";

@Component({
    selector: "createOrEditEventModal",
    templateUrl: "./create-or-edit-event-modal.component.html",
    styles: [
        `
            .certificate-img {
                width: 150px;
                height: 125px;
            }
        `,
    ],
})
export class CreateOrEditEventModalComponent
    extends AppComponentBase
    implements OnInit
{
    appConsts = AppConsts;
    addressDto = EventAddressDto;
    paymentMethod = PaymentMethod;
    certificateType = CertificateType;

    @ViewChild("createOrEditModal") modal: ModalDirective;
    @ViewChild("addresses") addresses: AddressesComponent;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    languages: abp.localization.ILanguageInfo[] = [];

    active = false;
    saving = false;

    event: CreateOrEditEventDto = new CreateOrEditEventDto();
    public emailConfig: EmailConfigDto = new EmailConfigDto();

    countName = 0;
    cigamCode = "";

    statusIntegracao = StatusIntegracao;

    types = [];
    events = [];
    paymentMethods = [];

    public uploader: FileUploader;
    public temporaryPictureUrl: string;
    eventPicture: string;
    selectedDescription: LanguageTextDto;
    selectedPolicy: LanguageTextDto;
    selectedEmailText: LanguageTextDto;
    selectedCertificateTexts: LanguageTextDto[] = [];
    selectedDescriptionLanguage: string;
    selectedPolicyLanguage: string;
    selectedEmailTextLanguage: string;
    selectedCertificatesLanguages = [];
    showInstructions: boolean;
    showEmailInstructions: boolean;
    urlPreview = null;
    linkSite = undefined;

    uploadUrl: string =
        AppConsts.remoteServiceBaseUrl + "/User/UploadDocumentation";
    uploadedFiles: any[] = [];
    uploadedFilesRenamed: any[] = [];
    deletedAnyDocuments = false;

    currentDate = moment();
    availableCertificateTypes = [
        CertificateType.Appraiser,
        CertificateType.Author,
        CertificateType.Congressman,
        CertificateType.Instructor,
        CertificateType.Speaker,
        CertificateType.Participant,
    ];

    private maxProfilPictureBytesUserFriendlyValue = 5;
    private temporaryPictureFileName: string;
    private _uploaderOptions: FileUploaderOptions = {};
    private _$eventPictureResize: JQuery;
    private _$jcropApi: any;

    public uploaderCertificate: FileUploader;
    public temporaryCertificateUrl: string;
    private temporaryCertificateFileName: string;
    private _uploaderCertificateOptions: FileUploaderOptions = {};

    public uploaderCertificateCNA: FileUploader;
    public temporaryCertificateCNAUrl: string;
    private temporaryCertificateCNAFileName: string;
    private _uploaderCertificateCNAOptions: FileUploaderOptions = {};

    public uploaderScientific: FileUploader;
    public temporaryScientificUrl: string;
    private temporaryScientificFileName: string;
    private _uploaderScientificOptions: FileUploaderOptions = {};

    msgNumberOfPlaces = this.l("You can type 0 to number of places unlimited.");
    msgGroup = this.l("Number of CIGAM group");
    msgSubGroup = this.l("Number of CIGAM subgroup");
    msgAccount = this.l("Code of financial account");
    msgGerencialAccount = this.l("Code of gerencial account");
    msgCode = this.l("Code of CIGAM Material 4 digits");
    msgDeadline = this.l(
        "This field is dedicated to Directors, Scientific Commission and Guests."
    );

    constructor(
        injector: Injector,
        private _eventsService: EventsServiceProxy,
        private _userService: UserServiceProxy,
        private _eventTypesService: EventTypesServiceProxy,
        private _paymentMethodsService: PaymentMethodsServiceProxy,
        private _tokenService: TokenService,
        private _certificatesService: CertificatesServiceProxy,
        private _fileDownloadService: FileDownloadService
    ) {
        super(injector);
    }

    ngOnInit(): void {
        this.selectedDescriptionLanguage =
            this.localization.currentLanguage.name;
        this.selectedPolicyLanguage = this.localization.currentLanguage.name;
        this.selectedEmailTextLanguage = this.localization.currentLanguage.name;

        this.loadPaymentMethods();
        this.loadEventTypes();
        this.initializeNewEvent();
    }

    ngAfterViewChecked(): void {
        //Temporary fix for: https://github.com/valor-software/ngx-bootstrap/issues/1508
        $("tabset ul.nav").addClass("m-tabs-line");
        $("tabset ul.nav li a.nav-link").addClass("m-tabs__link");

        $(".datetimepicker").datetimepicker({
            locale: abp.localization.currentLanguage.name,
            format: "L",
        });

        $('[data-toggle="m-tooltip"]').tooltip();
    }

    setDescriptionLanguage(event: any) {
        this.selectedDescriptionLanguage = event.target.value;
        this.selectedDescription = this.event.descriptions.filter(
            (x) => x.languageName == this.selectedDescriptionLanguage
        )[0];
        if (!this.selectedDescription) {
            this.selectedDescription = new LanguageTextDto();
            this.selectedDescription.languageName =
                this.selectedDescriptionLanguage;
        }
    }

    setDescription() {
        this.selectedDescription.source = "SGM";
        this.selectedDescription.languageName =
            this.selectedDescriptionLanguage;
        var lang = this.event.descriptions.filter(
            (x) => x.languageName == this.selectedDescriptionLanguage
        )[0];
        if (!lang) this.event.descriptions.push(this.selectedDescription);
        else lang.value = this.selectedDescription.value;
    }

    setPolicyLanguage(event: any) {
        this.selectedPolicyLanguage = event.target.value;
        this.selectedPolicy =
            this.event.contract.cancellationAndTransferPolicyTexts.filter(
                (x) => x.languageName == this.selectedPolicyLanguage
            )[0];
        if (!this.selectedPolicy) {
            this.selectedPolicy = new LanguageTextDto();
            this.selectedPolicy.languageName = this.selectedPolicyLanguage;
        }
    }

    setPolicy() {
        this.selectedPolicy.source = "SGM";
        this.selectedPolicy.languageName = this.selectedPolicyLanguage;
        var lang =
            this.event.contract.cancellationAndTransferPolicyTexts.filter(
                (x) => x.languageName == this.selectedPolicyLanguage
            )[0];
        if (!lang)
            this.event.contract.cancellationAndTransferPolicyTexts.push(
                this.selectedPolicy
            );
        else lang.value = this.selectedPolicy.value;
    }

    setCertificateLanguage(event: any, i: number) {
        this.selectedCertificatesLanguages[i] = event.target.value;
        if (this.event.certificateConfig.texts[i].texts)
            this.selectedCertificateTexts[i] =
                this.event.certificateConfig.texts[i].texts.filter(
                    (x) => x.languageName == event.target.value
                )[0];

        if (!this.selectedCertificateTexts[i]) {
            this.selectedCertificateTexts[i] = new LanguageTextDto();
            this.selectedCertificateTexts[i].languageName = event.target.value;
            this.event.certificateConfig.texts[i].texts.push(
                this.selectedCertificateTexts[i]
            );
        }
    }

    setCertificateText(i: number) {
        this.selectedCertificateTexts[i].source = "SGM";
        this.selectedCertificateTexts[i].languageName = this
            .selectedCertificatesLanguages[i]
            ? this.selectedCertificatesLanguages[i]
            : "pt-BR";
        var lang = undefined;
        if (this.event.certificateConfig.texts[i].texts) {
            lang = this.event.certificateConfig.texts[i].texts.filter(
                (x) => x.languageName == this.selectedCertificatesLanguages[i]
            )[0];
        }

        if (!lang) {
            this.event.certificateConfig.texts[i].texts = [];
            this.event.certificateConfig.texts[i].texts.push(
                this.selectedCertificateTexts[i]
            );
        } else {
            lang.value = this.selectedCertificateTexts[i].value;
        }
    }

    setEmailLanguage(event: any) {
        this.selectedEmailTextLanguage = event.target.value;
        this.selectedEmailText = this.emailConfig.texts.filter(
            (x) => x.languageName == this.selectedEmailTextLanguage
        )[0];
        if (!this.selectedEmailText) {
            this.selectedEmailText = new LanguageTextDto();
            this.selectedEmailText.languageName =
                this.selectedEmailTextLanguage;
        }
    }

    setEmailText() {
        this.selectedEmailText.source = "SGM";
        this.selectedEmailText.languageName = this.selectedEmailTextLanguage;
        var lang = this.emailConfig.texts.filter(
            (x) => x.languageName == this.selectedEmailTextLanguage
        )[0];
        if (!lang) this.emailConfig.texts.push(this.selectedEmailText);
        else lang.value = this.selectedEmailText.value;
    }

    close(): void {
        this.active = false;
        this.cigamCode = undefined;
        this.selectedDescription = undefined;
        this.selectedDescriptionLanguage =
            this.localization.currentLanguage.name;
        this.selectedPolicy = undefined;
        this.selectedPolicyLanguage = this.localization.currentLanguage.name;
        this.selectedEmailText = undefined;
        this.selectedEmailTextLanguage = this.localization.currentLanguage.name;
        this.selectedCertificatesLanguages = [];
        this.selectedCertificateTexts = [];
        this.modal.hide();
    }

    onShown(): void {
        this.modal.show();
        this._$eventPictureResize = $("#EventPictureResize");
    }

    formAddressesIsInvalid(): boolean {
        return this.addresses && this.addresses.addressesForm.invalid;
    }

    addErrorTabAddresses(): string {
        return this.formAddressesIsInvalid() &&
            this.addresses.addressesForm.touched
            ? "has-error-tab"
            : "";
    }

    endDateIsInvalid(): boolean {
        return (
            this.event.endDate.startOf("day") <
            this.event.beginDate.startOf("day")
        );
    }

    beginInscriptionDateIsInvalid(): boolean {
        return (
            this.event.beginInscriptionDate.startOf("day") >
            this.event.endDate.startOf("day")
        );
    }

    endInscriptionDateIsInvalid(): boolean {
        return (
            this.event.endInscriptionDate.startOf("day") <
            this.event.beginInscriptionDate.startOf("day")
        );
    }

    endInscriptionDateIsEventInvalid(): boolean {
        return (
            this.event.endInscriptionDate.startOf("day") >
            this.event.endDate.startOf("day")
        );
    }

    formIsValid(formValid: boolean): boolean {
        return (
            formValid &&
            !this.endDateIsInvalid() &&
            !this.beginInscriptionDateIsInvalid() &&
            !this.endInscriptionDateIsInvalid() &&
            !this.endInscriptionDateIsEventInvalid() &&
            !this.formAddressesIsInvalid()
        );
    }

    initializeNewEvent(): void {
        this.event = new CreateOrEditEventDto();
        this.event.contract = new ContractDto();
        this.selectedPolicy = new LanguageTextDto();
        this.selectedPolicy.languageName = this.selectedDescriptionLanguage;
        this.event.certificateConfig = new CertificateConfigDto();
        this.addTypeText(CertificateType.Participant);

        this.event.beginDate = moment().startOf("day");
        this.event.endDate = moment().add(7, "days").endOf("day");
        this.event.beginInscriptionDate = moment().startOf("day");
        this.event.endInscriptionDate = moment().add(7, "days").endOf("day");
        this.event.categoryDeadlines = [];
        this.event.paymentMethods = [];
        this.event.place = new EventPlaceDto();
        this.event.emailConfigs = [];
        this.emailConfig.attachments = [];
        this.event.place.addresses = [];
        this.event.descriptions = [];
        this.selectedDescription = new LanguageTextDto();
        this.selectedDescription.languageName =
            this.selectedDescriptionLanguage;
    }

    public show(eventId?: number): void {
        this.initFileUploader();
        this.initCertificateUploader();
        this.initCertificateCNAUploader();
        this.initScientificUploader();

        this.initializeNewEvent();
        this.active = true;

        eventId = eventId ? eventId : 0;

        this._eventsService.getEventForEdit(eventId).subscribe((result) => {
            this.linkSite =
                AppConsts.appBaseUrl +
                "/app/event/registration?eventId=" +
                eventId;

            if (result.event) this.event = result.event;

            if (!this.event.contract) {
                this.event.contract = new ContractDto();
            }

            if (
                this.event.contract.cancellationAndTransferPolicyTexts &&
                this.event.contract.cancellationAndTransferPolicyTexts.length >
                    0
            ) {
                var lang =
                    this.event.contract.cancellationAndTransferPolicyTexts.filter(
                        (x) => x.languageName == this.selectedPolicyLanguage
                    )[0];

                this.selectedPolicy = lang
                    ? lang
                    : this.event.contract.cancellationAndTransferPolicyTexts[0];
            } else {
                this.selectedPolicy = new LanguageTextDto();
                this.selectedPolicy.source = "SGM";
                this.selectedPolicy.languageName = this.selectedPolicyLanguage;
            }

            if (this.event.descriptions && this.event.descriptions.length > 0) {
                var lang = this.event.descriptions.filter(
                    (x) => x.languageName == this.selectedDescriptionLanguage
                )[0];

                this.selectedDescription = lang
                    ? lang
                    : this.event.descriptions[0];
            } else {
                this.selectedDescription = new LanguageTextDto();
                this.selectedDescription.source = "SGM";
                this.selectedDescription.languageName =
                    this.selectedDescriptionLanguage;
            }

            if (!this.event.certificateConfig)
                this.event.certificateConfig = new CertificateConfigDto();

            if (
                !this.event.certificateConfig.texts ||
                this.event.certificateConfig.texts.length == 0
            ) {
                this.addTypeText(CertificateType.Participant);
            } else this.checkTextCertificateText();

            if (!this.event.programmingImageInput)
                this.event.programmingImageInput = new UpdateEventImageInput();

            if (this.event.place.addresses.length == 0) {
                let address = new EventAddressDto();
                address.countryName = "BRASIL";
                address.type = EventAddressType.Business;
                this.event.place.addresses.push(address);
            }

            if (this.event.emailConfigs && this.event.emailConfigs.length) {
                this.emailConfig = this.event.emailConfigs[0];
            } else {
                this.emailConfig = new EmailConfigDto();
                this.emailConfig.texts = [];
            }

            if (this.emailConfig && this.emailConfig.texts.length) {
                var lang = this.emailConfig.texts.filter(
                    (x) => x.languageName == this.selectedEmailTextLanguage
                )[0];

                this.selectedEmailText = lang
                    ? lang
                    : this.emailConfig.texts[0];
            } else {
                this.selectedEmailText = new LanguageTextDto();
                this.selectedEmailText.source = "SGM";
                this.selectedEmailText.languageName =
                    this.selectedEmailTextLanguage;
            }

            if (this.event.codigoMaterial)
                this.cigamCode = this.event.codigoMaterial.substring(4, 8);

            this.getEventPicture(this.event.eventImageId);

            this.modal.show();
        });
    }

    save(): void {
        let model = new CreateOrEditEventDto();
        model.id = this.event.id;
        model.name = this.event.name;
        model.shortName = this.event.shortName;
        model.numberOfPlaces = this.event.numberOfPlaces;
        model.requireRelatedEventInscription =
            this.event.requireRelatedEventInscription;
        model.description = this.event.description;
        model.time = this.event.time;
        model.note = this.event.note;
        model.allowGoogleCalendar = this.event.allowGoogleCalendar;
        model.allowYahooCalendar = this.event.allowYahooCalendar;
        model.allowICalCalendar = this.event.allowICalCalendar;
        model.codigoGrupo = this.event.codigoGrupo;
        model.codigoSubGrupo = this.event.codigoSubGrupo;
        model.codigoMaterial = this.cigamCode
            ? this.event.codigoGrupo +
              this.event.codigoSubGrupo +
              this.cigamCode
            : undefined;
        model.codigoContaFinanceira = this.event.codigoContaFinanceira;
        model.codigoContaGerencial = this.event.codigoContaGerencial;

        if (model.requireRelatedEventInscription)
            model.relatedEventId = this.event.relatedEvent.id;

        model.displayAsFirstOnSite = this.event.displayAsFirstOnSite;
        model.beginDate = this.event.beginDate;
        model.endDate = this.event.endDate;
        model.beginInscriptionDate = this.event.beginInscriptionDate;
        model.endInscriptionDate = this.event.endInscriptionDate;
        model.eventTypeId = this.event.eventTypeId;

        model.contract = new ContractDto();
        model.contract.daysToUnsubscribe =
            this.event.contract.daysToUnsubscribe;
        model.contract.daysToTransferARegistration =
            this.event.contract.daysToTransferARegistration;
        model.contract.daysToTransferARegistrationForAnotherUser =
            this.event.contract.daysToTransferARegistrationForAnotherUser;
        model.contract.cancellationAndTransferPolicyText =
            this.event.contract.cancellationAndTransferPolicyText;
        model.contract.cancellationDiscountPercentage =
            this.event.contract.cancellationDiscountPercentage;
        model.contract.creditCardPaymentDiscountPercentage =
            this.event.contract.creditCardPaymentDiscountPercentage;
        model.contract.daysToPayment = this.event.contract.daysToPayment;

        if (this.event.contract.cancellationAndTransferPolicyText.length) {
            model.contract.cancellationAndTransferPolicyTexts = [];
            this.event.contract.cancellationAndTransferPolicyTexts.forEach(
                (x) => {
                    model.contract.cancellationAndTransferPolicyTexts.push(x);
                }
            );
        }

        model.place = this.event.place;
        model.place.id = undefined;
        model.place.addresses.forEach((x) => (x.id = undefined));

        model.categoryDeadlines = [];
        this.event.categoryDeadlines.forEach((x) => {
            let category = new EventCategoryDeadlineDto();
            category.id = x.id;
            category.description = x.description;
            category.value = x.value;
            category.deadline = x.deadline;
            (category.numberOfInstallments = x.numberOfInstallments),
                (category.onLocal = x.onLocal);
            category.isAdministrative = x.isAdministrative;
            model.categoryDeadlines.push(category);
        });

        model.paymentMethods = [];
        this.event.paymentMethods.forEach((x) => {
            let paymentMethodPermission = new EventPaymentMethodPermissionDto();
            paymentMethodPermission.paymentMethodId = x.paymentMethod.id;
            paymentMethodPermission.fee = x.fee;
            paymentMethodPermission.percentDiscount = x.percentDiscount;
            paymentMethodPermission.isAllowed = x.isAllowed;
            model.paymentMethods.push(paymentMethodPermission);
        });

        model.eventImageId = this.event.eventImageId;
        model.eventImageInput = this.getInputPicture();

        if (this.event.certificateConfig) {
            model.certificateConfig = new CertificateConfigDto();

            if (this.temporaryCertificateFileName) {
                model.certificateConfig.defaultImageInput =
                    new UpdateCertificateImageInput();
                model.certificateConfig.defaultImageInput.fileName =
                    this.temporaryCertificateFileName;
            } else {
                model.certificateConfig.defaultImageId =
                    this.event.certificateConfig.defaultImageId;
            }

            if (this.temporaryCertificateCNAFileName) {
                model.certificateConfig.cnaImageInput =
                    new UpdateCertificateImageInput();
                model.certificateConfig.cnaImageInput.fileName =
                    this.temporaryCertificateCNAFileName;
            } else {
                model.certificateConfig.cnaImageId =
                    this.event.certificateConfig.cnaImageId;
            }

            model.certificateConfig.texts = [];

            this.event.certificateConfig.texts.forEach((text) => {
                let modelText = new CertificateConfigTextDto();
                modelText.certificateType = text.certificateType;
                modelText.text = text.text;
                modelText.texts = text.texts;
                model.certificateConfig.texts.push(modelText);
            });
        }

        if (this.temporaryScientificFileName) {
            model.programmingImageInput = new UpdateEventImageInput();
            model.programmingImageInput.fileName =
                this.temporaryScientificFileName;
        } else {
            model.programmingImageId = this.event.programmingImageId;
        }

        if (this.emailConfig) {
            model.emailConfigs = new Array<EmailConfigDto>();
            model.emailConfigs.push(this.emailConfig);

            this.uploadedFilesRenamed.forEach((x) => {
                let doc = new DocumentEditDto();
                doc.input = new UpdateDocumentInput();
                doc.input.fileName = x.fileName;

                model.emailConfigs[0].attachments.push(doc);
            });
        }

        if (this.event.descriptions.length) {
            model.descriptions = [];
            this.event.descriptions.forEach((x) => {
                model.descriptions.push(x);
            });
        }

        this._eventsService
            .createOrUpdateEvent(model)
            .finally(() => {
                this.saving = false;
            })
            .subscribe(() => {
                this.notify.info(this.l("SavedSuccessfully"));
                this.close();
                this.modalSave.emit(null);
            });
    }

    /// Event Informations

    // Upadate Begin Date Event
    upadateBeginDate(value: string) {
        this.event.beginDate = value ? moment(value, "L") : null;
    }

    // Upadate End Date Event
    upadateEndDate(value: string) {
        this.event.endDate = value ? moment(value, "L") : null;
    }

    // Upadate Begin Date Inscription
    upadateBeginInscriptionDate(value: string) {
        this.event.beginInscriptionDate = value ? moment(value, "L") : null;
    }

    // Upadate End Date Inscription
    upadateEndInscriptionDate(value: string) {
        this.event.endInscriptionDate = value ? moment(value, "L") : null;
    }

    // Get Events
    filterEvents(event): void {
        this._eventsService
            .getEventsForSelect(
                event.query,
                this.event.id,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                10,
                0
            )
            .subscribe((result) => {
                this.events = result.items;
            });
    }

    /// Category Deadlines
    addDeadline() {
        let deadline = new EventCategoryDeadlineDto();
        deadline.deadline = moment().startOf("day");
        deadline.id = this.countName--;

        this.event.categoryDeadlines.push(deadline);
    }

    deleteDeadline(index: number): void {
        this.event.categoryDeadlines.splice(index, 1);
    }

    upadateDateDeadline(value: string, i: number) {
        this.event.categoryDeadlines[i].deadline = value
            ? moment(value, "L")
            : moment();
    }

    /// Payment Methods

    addPaymentMethod(): void {
        let paymentMethod = new EventPaymentMethodPermissionDto();
        paymentMethod.percentDiscount = 0;
        paymentMethod.fee = 1;
        paymentMethod.isAllowed = true;
        paymentMethod.id = this.countName--;

        this.event.paymentMethods.push(paymentMethod);
    }

    deletePaymentMethod(index: number): void {
        this.event.paymentMethods.splice(index, 1);
    }

    // Get Payment Methods
    loadPaymentMethods(): void {
        this._paymentMethodsService
            .getPaymentMethodsForSelect(undefined, true, false)
            .subscribe((result) => {
                this.paymentMethods = result.items;
            });
    }

    loadEventTypes(): void {
        this._eventTypesService
            .getEventTypesForSelect("")
            .subscribe((result) => {
                this.types = result.items;
            });
    }

    getMaxFee(
        paymentMethodPermission: EventPaymentMethodPermissionDto
    ): number {
        if (paymentMethodPermission.paymentMethod)
            return paymentMethodPermission.paymentMethod.maxFee;
        else return 1;
    }

    checkPaymentMethod(index: number) {
        if (
            !!this.event.paymentMethods[index].paymentMethod &&
            !!this.event.paymentMethods[index].paymentMethod.maxFee &&
            this.event.paymentMethods[index].paymentMethod.maxFee == 1
        ) {
            this.event.paymentMethods[index].fee = 1;

            if (
                this.event.paymentMethods[index].paymentMethod
                    .paymentMethodType == PaymentMethod.Coupon
            ) {
                this.event.paymentMethods[index].percentDiscount = 0;
            }
        }
    }

    /// Picture
    getEventPicture(eventPictureId: string): void {
        if (!eventPictureId) {
            this.eventPicture = "/assets/common/images/event.jpeg";
        } else {
            this._eventsService
                .getEventImageById(eventPictureId)
                .subscribe((result) => {
                    if (result && result.eventImage)
                        this.eventPicture =
                            "data:image/jpeg;base64," + result.eventImage;
                });
        }
    }

    initFileUploader(): void {
        this.temporaryPictureUrl = "";
        this.temporaryPictureFileName = "";
        this._$eventPictureResize = null;
        this._$jcropApi = null;

        const self = this;
        self.uploader = new FileUploader({
            url: AppConsts.remoteServiceBaseUrl + "/Event/UploadEventImage",
        });
        self._uploaderOptions.autoUpload = true;
        self._uploaderOptions.authToken =
            "Bearer " + self._tokenService.getToken();
        self._uploaderOptions.removeAfterUpload = true;
        self.uploader.onAfterAddingFile = (file) => {
            file.withCredentials = false;
        };

        self.uploader.onSuccessItem = (item, response, status) => {
            const resp = <IAjaxResponse>JSON.parse(response);
            if (resp.success) {
                self.temporaryPictureFileName = resp.result.fileName;
                self.temporaryPictureUrl =
                    AppConsts.remoteServiceBaseUrl +
                    "/Temp/Downloads/" +
                    resp.result.fileName +
                    "?v=" +
                    new Date().valueOf();

                const newCanvasHeight =
                    (resp.result.height * self._$eventPictureResize.width()) /
                    resp.result.width;
                self._$eventPictureResize.height(newCanvasHeight + "px");

                if (self._$jcropApi) {
                    self._$jcropApi.destroy();
                }

                self._$eventPictureResize.attr("src", self.temporaryPictureUrl);
                self._$eventPictureResize.attr(
                    "originalWidth",
                    resp.result.width
                );
                self._$eventPictureResize.attr(
                    "originalHeight",
                    resp.result.height
                );

                self._$eventPictureResize.Jcrop(
                    {
                        setSelect: [0, 0, 100, 100],
                        aspectRatio: 1,
                        boxWidth: 400,
                        boxHeight: 400,
                    },
                    function () {
                        self._$jcropApi = this;
                    }
                );
            } else {
                this.message.error(resp.error.message);
            }
        };

        self.uploader.setOptions(self._uploaderOptions);
    }

    getInputPicture(): UpdateEventImageInput {
        const self = this;
        if (!self.temporaryPictureFileName) {
            return undefined;
        }

        let resizeParams = { x: 0, y: 0, w: 0, h: 0 };
        if (self._$jcropApi) {
            resizeParams = self._$jcropApi.ui.selection.last;
        }

        const containerWidth = parseInt(self._$jcropApi.getContainerSize()[0]);
        const containerHeight = self._$jcropApi.getContainerSize()[1];

        let originalWidth = containerWidth;
        let originalHeight = containerHeight;

        if (self._$eventPictureResize) {
            originalWidth = parseInt(
                self._$eventPictureResize.attr("originalWidth")
            );
            originalHeight = parseInt(
                self._$eventPictureResize.attr("originalHeight")
            );
        }

        const widthRatio = originalWidth / containerWidth;
        const heightRatio = originalHeight / containerHeight;

        const input = new UpdateEventImageInput();
        //input.eventId = self.event.id;
        input.fileName = self.temporaryPictureFileName;
        input.x = Math.floor(resizeParams.x * widthRatio);
        input.y = Math.floor(resizeParams.y * heightRatio);
        input.width = Math.floor(resizeParams.w * widthRatio) - 3;
        input.height = Math.floor(resizeParams.h * heightRatio) - 3;

        return input;
    }

    // Certificates

    initCertificateUploader(): void {
        this.temporaryCertificateUrl = "";
        this.temporaryCertificateFileName = "";

        this.uploaderCertificate = new FileUploader({
            url:
                AppConsts.remoteServiceBaseUrl +
                "/Event/UploadCertificateImage",
        });
        this._uploaderCertificateOptions.autoUpload = true;
        this._uploaderCertificateOptions.authToken =
            "Bearer " + this._tokenService.getToken();
        this._uploaderCertificateOptions.removeAfterUpload = true;
        this._uploaderCertificateOptions.additionalParameter = {
            isCna: "false",
        };
        this.uploaderCertificate.onAfterAddingFile = (file) => {
            file.withCredentials = false;
        };
        this.uploaderCertificate.onSuccessItem = (item, response, status) => {
            const resp = <IAjaxResponse>JSON.parse(response);
            if (resp.success && resp.result.fileName) {
                this.temporaryCertificateFileName = resp.result.fileName;
                this.temporaryCertificateUrl =
                    AppConsts.remoteServiceBaseUrl +
                    "/Temp/Downloads/" +
                    resp.result.fileName +
                    "?v=" +
                    new Date().valueOf();
            } else {
                let message = resp.error
                    ? resp.error.message
                    : resp.result.message;
                this.message.error(message);
            }
        };
        this.uploaderCertificate.setOptions(this._uploaderCertificateOptions);
    }

    initCertificateCNAUploader(): void {
        this.temporaryCertificateCNAUrl = "";
        this.temporaryCertificateCNAFileName = "";

        this.uploaderCertificateCNA = new FileUploader({
            url:
                AppConsts.remoteServiceBaseUrl +
                "/Event/UploadCertificateImage",
        });
        this._uploaderCertificateCNAOptions.autoUpload = true;
        this._uploaderCertificateCNAOptions.authToken =
            "Bearer " + this._tokenService.getToken();
        this._uploaderCertificateCNAOptions.removeAfterUpload = true;
        this._uploaderCertificateCNAOptions.additionalParameter = {
            isCna: "true",
        };
        this.uploaderCertificateCNA.onAfterAddingFile = (file) => {
            file.withCredentials = false;
        };
        this.uploaderCertificateCNA.onSuccessItem = (
            item,
            response,
            status
        ) => {
            const resp = <IAjaxResponse>JSON.parse(response);
            if (resp.success) {
                this.temporaryCertificateCNAFileName = resp.result.fileName;
                this.temporaryCertificateCNAUrl =
                    AppConsts.remoteServiceBaseUrl +
                    "/Temp/Downloads/" +
                    resp.result.fileName +
                    "?v=" +
                    new Date().valueOf();
            } else {
                let message = resp.error
                    ? resp.error.message
                    : resp.result.message;
                this.message.error(message);
            }
        };
        this.uploaderCertificateCNA.setOptions(
            this._uploaderCertificateCNAOptions
        );
    }

    getCertificatePreview(type: CertificateType) {
        if (
            !this.temporaryCertificateUrl &&
            !this.event.certificateConfig.defaultImage
        ) {
            this.message.warn(
                this.l("Necessary select the certificate image.")
            );
        } else {
            let model = new GetCertificatePreviewInput();
            model.event = new CertificatePreviewEvent();
            model.event.id = this.event.id;
            model.event.name = this.event.name;
            model.event.beginDate = this.event.beginDate;
            model.event.endDate = this.event.endDate;
            model.event.place = this.event.place;

            model.event.certificateConfig = new CertificateConfigDto();

            if (this.temporaryCertificateFileName) {
                model.event.certificateConfig.defaultImageInput =
                    new UpdateCertificateImageInput();
                model.event.certificateConfig.defaultImageInput.fileName =
                    this.temporaryCertificateFileName;
            } else {
                model.event.certificateConfig.defaultImageId =
                    this.event.certificateConfig.defaultImageId;
            }

            if (this.temporaryCertificateCNAFileName) {
                model.event.certificateConfig.cnaImageInput =
                    new UpdateCertificateImageInput();
                model.event.certificateConfig.cnaImageInput.fileName =
                    this.temporaryCertificateCNAFileName;
            } else {
                model.event.certificateConfig.cnaImageId =
                    this.event.certificateConfig.cnaImageId;
            }

            model.event.certificateConfig.texts = [];

            this.event.certificateConfig.texts.forEach((text) => {
                if (text.certificateType == type) {
                    let modelText = new CertificateConfigTextDto();
                    modelText.id = text.id;
                    modelText.certificateType = text.certificateType;
                    modelText.text = text.text;
                    model.event.certificateConfig.texts.push(modelText);
                    model.type = Number(type);
                }
            });

            this._certificatesService
                .requestPreview(model)
                .subscribe((result) => {
                    this._fileDownloadService.downloadTempFile(result);
                });
        }
    }

    // Scientific

    initScientificUploader(): void {
        this.temporaryScientificUrl = "";
        this.temporaryScientificFileName = "";

        this.uploaderScientific = new FileUploader({
            url:
                AppConsts.remoteServiceBaseUrl +
                "/Event/UploadProgrammingImage",
        });
        this._uploaderScientificOptions.autoUpload = true;
        this._uploaderScientificOptions.authToken =
            "Bearer " + this._tokenService.getToken();
        this._uploaderScientificOptions.removeAfterUpload = true;
        this.uploaderScientific.onAfterAddingFile = (file) => {
            file.withCredentials = false;
        };
        this.uploaderScientific.onSuccessItem = (item, response, status) => {
            const resp = <IAjaxResponse>JSON.parse(response);
            if (resp.success && resp.result.fileName) {
                this.temporaryScientificFileName = resp.result.fileName;
                this.temporaryScientificUrl =
                    AppConsts.remoteServiceBaseUrl +
                    "/Temp/Downloads/" +
                    resp.result.fileName +
                    "?v=" +
                    new Date().valueOf();
            } else {
                let message = resp.error
                    ? resp.error.message
                    : resp.result.message;
                this.message.error(message);
            }
        };
        this.uploaderScientific.setOptions(this._uploaderScientificOptions);
    }

    copyToClipboard() {
        var $temp = $("<input>");
        $("body").append($temp);
        $temp.val(this.linkSite).select();
        document.execCommand("copy");
        $temp.remove();
    }

    addTypeText(type): void {
        if (
            !this.event.certificateConfig.texts ||
            this.event.certificateConfig.texts.length == 0
        ) {
            this.event.certificateConfig.texts = [];
        }

        let textModel = new CertificateConfigTextDto();
        textModel.certificateType = type;
        this.event.certificateConfig.texts.push(textModel);

        var t = new LanguageTextDto();
        t.languageName = this.localization.currentLanguage.name;
        this.selectedCertificateTexts.push(t);
        this.setCertificateLanguage(
            { target: { value: this.localization.currentLanguage.name } },
            0
        );

        this.checkTextCertificateText();
    }

    deleteText(index: number): void {
        this.event.certificateConfig.texts.splice(index, 1);
        this.selectedCertificateTexts.splice(index, 1);
        this.selectedCertificatesLanguages.splice(index, 1);
        this.checkTextCertificateText();
    }

    checkTextCertificateText(): void {
        let allCertificateTypes = [
            CertificateType.Appraiser,
            CertificateType.Author,
            CertificateType.Congressman,
            CertificateType.Instructor,
            CertificateType.Speaker,
            CertificateType.Participant,
        ];

        this.event.certificateConfig.texts.forEach((text) => {
            for (let i = 0; i < allCertificateTypes.length; i++) {
                if (allCertificateTypes[i] == text.certificateType) {
                    allCertificateTypes.splice(i, 1);
                    if (text.texts && text.texts.length) {
                        if (this.selectedCertificateTexts.length >= i)
                            this.selectedCertificateTexts.splice(i, 1);

                        var t = new LanguageTextDto();
                        t.languageName = this.localization.currentLanguage.name;
                        t.value = text.texts[0].value;
                        if (
                            this.selectedCertificateTexts.filter(
                                (x) => x.languageName == t.languageName
                            ).length
                        ) {
                            this.selectedCertificateTexts.filter(
                                (x) => x.languageName == t.languageName
                            )[0].value = text.texts[0].value;
                        } else {
                            this.selectedCertificateTexts.push(t);
                            //this.setCertificateLanguage({target: { value: this.localization.currentLanguage.name }}, i);
                        }
                    }

                    i = 0;
                }
            }
        });

        this.availableCertificateTypes = allCertificateTypes;
    }

    // Documents
    onUpload(event): void {
        for (let file of event.files) {
            this.uploadedFiles.push(file);
        }

        if (event.xhr) {
            this.readFiles(event.xhr.response);
        }
    }

    onBeforeSend(event): void {
        event.xhr.setRequestHeader(
            "Authorization",
            "Bearer " + abp.auth.getToken()
        );
    }

    readFiles(response) {
        try {
            let filesRenamed = JSON.parse(response).result;

            filesRenamed.forEach((x) => {
                this.uploadedFilesRenamed.push(x);
            });
        } catch (e) {}
    }

    deletePendingDocument(index: number): void {
        this.uploadedFiles.splice(index, 1);
        this.uploadedFilesRenamed.splice(index, 1);
    }

    deleteDocument(index: number): void {
        this.deletedAnyDocuments = true;
        this.emailConfig.attachments.splice(index, 1);
    }

    downloadFile(document: DocumentDto): void {
        this.loading = true;

        this._userService
            .getFile(document.documentId, document.fileExtension, document.id)
            .finally(() => {
                this.loading = false;
            })
            .subscribe((result) => {
                this._fileDownloadService.downloadTempFile(result);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/event/events/modals/create-or-edit/create-or-edit-event-modal.component.ts